import { render } from "./FbnLookup.vue?vue&type=template&id=d2bdd9a4"
import script from "./FbnLookup.vue?vue&type=script&lang=js"
export * from "./FbnLookup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__